module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingClans/components/SearchControl/images/clear-icon.0adbb37c.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingClans/components/SearchControl/images/clear-icon.png
// module id = 3133
// module chunks = 11